import { getIdFromURL } from 'vue-youtube-embed'
import { isString } from 'lodash';

const SOURCES = {
  YOUTUBE: 1,
  VIMEO: 2,
}

export default {
  props: {
    autoPlay: {},
    loop: {},
    mute: {},
    source: {},
    startTime: {},
    videoUrl: {},
    maxHeight: {},
  },
  computed: {
    classModifiers() {
      return {
        'video-view': true,
        'video-view--responsive': !this.playerHeight,
      };
    },
    isYoutube() {
      return this.source === SOURCES.YOUTUBE;
    },
    isVimeo() {
      return this.source === SOURCES.VIMEO;
    },
    youtubeVideoId() {
      return getIdFromURL(this.videoUrl);
    },
    youtubePlayerVars() {
      return {
        rel: 0,
        start: this.startTime,
        autoplay: (this.autoPlay) ? 1: 0
      }
    },
    playerHeight() {
      if (this.maxHeight) {
        return this.maxHeight;
      }
      return undefined;
    },
    playerWidth() {
      if (!this.playerHeight) {
        return '100%';
      }
      const height = isString(this.playerHeight) && this.playerHeight.endsWith('px') ? Number(this.playerHeight.replace('px', '').trim()) : this.playerHeight;
      const ratio = this.isVimeo ? 2 : 1.78;
      return height * ratio;
    },
    vimeoVideoId() {
      return /(vimeo(pro)?\.com)\/(?:[^\d]+)?(\d+)\??(.*)?$/.exec(this.videoUrl)[3];
    },
    vimeoPlayerVars() {
      const params = {
        responsive: !this.playerHeight,
        muted: this.mute,
        start_time: this.startTime,
      };
      return params;
    }
  },
  methods: {
    youtubeEnded() {
      if (this.loop && this.$refs.youtubePlayer) {
        this.$refs.youtubePlayer.player.seekTo(0)
      }
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/cms/video-view/video-view.js